<template>
    <div v-if="show" class="w-full bg-amber-50 border-b border-amber-200 px-4 py-2 flex items-center justify-between gap-4 text-sm">
        <div class="flex items-center gap-2 text-amber-800">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span v-if="daysLeft > 0">
                <strong>Período de teste:</strong> faltam {{ daysLeft }} dia{{ daysLeft !== 1 ? 's' : '' }} para encerrar.
            </span>
            <span v-else>
                <strong>Período de teste encerrado.</strong> Assine para continuar usando.
            </span>
        </div>
        <div class="flex items-center gap-2 shrink-0">
            <router-link :to="{ name: 'subscription' }" class="text-xs font-semibold text-amber-700 border border-amber-400 rounded px-2 py-1 hover:bg-amber-100 transition">
                Assinar agora
            </router-link>
            <button v-if="daysLeft > 0" @click="dismiss" class="text-amber-500 hover:text-amber-700" aria-label="Fechar">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import AuthService from '@/services/AuthService';
import LocalStorage from '@/services/LocalStorageService';

const LS_KEY = 'trial_banner_dismissed_at';
const DISMISS_MINUTES = 60;

export default {
    setup() {
        const show = ref(false);
        const daysLeft = ref(0);
        const route = useRoute();

        function shouldShow() {
            const auth = AuthService.getAuthInfo() || {};
            const status = auth.subscription_status;
            if (status === 'active' || status === 'past_due') return false;
            if (status !== 'trial' && status !== 'expired_trial') return false;

            daysLeft.value = Number.isFinite(Number(auth.days_left)) ? Number(auth.days_left) : 0;

            if (daysLeft.value <= 0) return true;

            const lastDismissed = LocalStorage.get(LS_KEY);
            if (!lastDismissed) return true;
            try {
                const diff = (Date.now() - new Date(JSON.parse(lastDismissed)).getTime()) / 60000;
                return diff > DISMISS_MINUTES;
            } catch {
                return true;
            }
        }

        function dismiss() {
            LocalStorage.set(LS_KEY, JSON.stringify(new Date().toISOString()));
            show.value = false;
        }

        onMounted(() => { show.value = shouldShow(); });
        watch(() => route.fullPath, () => { show.value = shouldShow(); });

        return { show, daysLeft, dismiss };
    }
};
</script>
